/**
 * @Desription: 登录-配置管理
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class configManager
*/
declare const window:any;
namespace configManager{
    export function setDefault(config:any){
        config.$login = window.jQuery(config.submitBtnEl).closest('.login');
        let staticRootPath:string = '';//默认的静态资源路径
        switch(config.userMode){
            case 'user':
                //用户模式
                staticRootPath = config.rootPath + 'dist/';
                break;
            case 'dev':
                //开发模式
                staticRootPath = config.rootPath + 'assets/';
                break;
        }
        config.staticRootPath = staticRootPath;
    }
    export function requestAesKey() {
        if (!window.NetstarApiConfig.aes || !window.NetstarApiConfig.aes.reg) {
            return;
        }
        if (!window.NetstarApiConfig.aes.key) {
            let ajaxConfig = {
                type: 'get',
                dataType: 'json',
                url: window.NetstarApiConfig.apiRootPath + 'aesKey',
                success: function (res) {
                    console.log("aes-key", window.jQuery.cookie('aes-key'));
                },
                error: window.NSLogin.ajaxError
            }
            window.jQuery.ajax(ajaxConfig);
        }
    }
}
export default configManager;